import React from 'react';

const TodayForecast = ({ forecast }) => {
  return (
    <div className="today-forecast-box">
      <div className="today-forecast-title">Today's Forecast</div>
      <div className="today-forecast-description">{forecast.description}</div>
      <div className="today-forecast-details">
        <div className="tonight-forecast">
          <div className="forecast-period">Tonight</div>
          <div className="forecast-text">{forecast.tonight}</div>
        </div>
        <div className="tomorrow-forecast">
          <div className="forecast-period">Tomorrow</div>
          <div className="forecast-text">{forecast.tomorrow}</div>
        </div>
      </div>
    </div>
  );
};

export default TodayForecast; 